export let PIPELINE_VARIABLES = {
  api: import.meta.env.VITE_API_SERVER,
  recaptchaSiteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY,
};
